
const WIP = () => {
    return (
        <div className="container home-banner home-text text-center">
            <h4>This site is under construction</h4>
        </div>
    )
}

export default WIP;